import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=f0cfd8fa&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0cfd8fa')) {
      api.createRecord('f0cfd8fa', component.options)
    } else {
      api.reload('f0cfd8fa', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=f0cfd8fa&", function () {
      api.rerender('f0cfd8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NbHHp5A2ZRL/JS/comp/FavElement.vue"
export default component.exports